:host {
  --background-color: #{$colorGrey20};
  --icon-color: #{$colorInfo50};
  --close-color: #{$colorGrey90};
  --label-color: #{$colorInfo70};
  --description-color: #{$colorGrey90};

  &[type="success"] {
    --label-color: #{$colorSuccess70};
    --icon-color: #{$colorSuccess50};
    --background-color: #{$colorSuccess20};
  }

  &[type="warning"] {
    --label-color: #{$colorWarning90};
    --icon-color: #{$colorWarning70};
    --background-color: #{$colorWarning20};
  }

  &[type="error"] {
    --label-color: #{$colorError70};
    --icon-color: #{$colorError50};
    --background-color: #{$colorError20};
  }

  &[type="page-message"] {
    --label-color: #{$colorInfo70};
    --icon-color: #{$colorInfo50};
    --background-color: #{$colorInfo20};
  }
}

.stzh-message {
  position: relative;
  display: flex;
  box-shadow: $boxShadowMessage;
  background-color: var(--background-color);
  border-radius: #{$buttonBorderRadius};

  &__content {
    @include spaceCurve("padding-top", "small");
    @include spaceCurve("padding-bottom", "small");
    @include spaceCurve("padding-right", "medium");
    @include spaceCurve("gap", "small");
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-left: space("medium");

    @include mq($from: small) {
      flex-direction: row;
      align-items: flex-start;
    }

    @include mq($from: medium) {
      padding-left: space("large");
    }
  }

  &__icon-wrapper {
    display: flex;
    flex-shrink: 0;
  }

  &__icon {
    --size: #{iconSize("large")};
    color: var(--icon-color);
  }

  &__text-wrapper {
    @include mq($from: small) {
      flex-grow: 1;
    }
    @include mq($from: large) {
      align-items: center;
    }
  }

  &__label {
    @include font("title");
    @include fontCurve("h4", "heading");
    color: var(--label-color);

    @include mq($from: large) {
      font-size: var(--stzh-font-deci-font-size) !important;
    }

    &:not(:empty) {
      margin-bottom: var(--stzh-space-xsmall);
    }
  }

  &__description {
    @include fontCurve("p1");
    color: var(--description-color);
  }

  &__description:not(:empty) + &__link:not(:empty) {
    @include spaceCurve("margin-top", "tiny");
  }

  &__close[variant="tertiary"] {
    --color: var(--close-color);

    position: absolute;
    top: 0;
    right: 0;
  }

  /* Only label variant */

  &:has(#{&}__description:empty):has(#{&}__link:empty) &__label:not(:empty) {
    margin-top: space("xxsmall");
    margin-bottom: 0;
  }

  /* Type page-message */

  &--type-page-message &__content {
    @include containerPadding;
    @include spaceCurve("padding-top", "small");
    @include spaceCurve("padding-bottom", "small");
    align-items: flex-start;
    flex-direction: row;

    @include mq($to: large) {
      padding-right: space("xxxlarge");
    }

    @include mq($from: large) {
      align-items: center;
    }
  }

  &--type-page-message &__text-wrapper {
    display: flex;
    flex-direction: column;

    @include mq($from: large) {
      flex-direction: row;
      @include spaceCurve("gap", "small");
    }
  }

  &--type-page-message &__icon {
    --size: #{iconSize("small")};
  }

  &--type-page-message &__label {
    @include font("title");
    @include fontCurve("p1");
    margin: 0;
  }

  &--type-page-message &__close {
    @include mq($from: small) {
      top: 10px;
      right: 10px;
    }
  }

  &--type-page-message &__text-wrapper &__link {
    @include mq($from: medium) {
      margin-top: 0;
    }
  }
}
